export default "__VITE_ASSET__9O81IUa3__"